import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.project.getDetail, { id }, options);
    if (error) return { error, status };
    return content || {
        id: '',
        name: '',
        code: '',
        budgetItem: '',
        depDuty: '',
        jobActivity: '',
        isMajor: false,
        nature: '',
        projType: '',
        mainLimit: '',
        startDate: '',
        endDate: '',
        disburseType: '',
        destUnit: '',
        fund: '',
        detail: '',
        compTpl: '',
        total: '',
        investment: '',
        level: '',
        sysProjType: '',
        paymentType: '',
        distribution: '',
        fundMgr: '',
        isPending: false,
        hotClass: '',
        isNewly: false,
        isCapital: false,
        isResearch: false,
        isReview: false,
        isInform: false,
        is3PMode: false,
        isSpecial: false,
        isInterest: false,
        bondCode: '',
        contactPer: '',
        contactTel: '',
        mobile: '',
        desc: '',
        remark: '',
    };
};
